import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";

import { environment } from "../../../../environments/environment";
import { User } from "../../../dtos/user.viewmodel";
import { AccountsService } from "../../../services/settings-service/accounts/accounts.service";
import { ErrorHandlerService } from "../../../services/shared/error-handler.service";
import { format } from "date-fns";

@Component({
  selector: "app-add-account",
  templateUrl: "./add-account.component.html",
  styleUrls: ["./add-account.component.css"],
})
export class AddAccountComponent implements OnInit {
  @Input() user: User;
  @Input() isEdit: boolean = false;
  documentForm: FormGroup;

  brokers;

  id: number;

  edit: boolean;

  roles: any;

  file_name: string;

  showError: boolean;

  messages = "";
  can_manage_payment_plan: boolean;
  can_export: boolean = false;
  can_import: boolean = false;
  is_accountant_cash: boolean;
  constructor(
    private accountService: AccountsService,
    public errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.id = +this.route.snapshot.params["id"];
    this.http.get(`${environment.api_base_url}get_roles`).subscribe(
      (data) => {
        this.roles = data;
      },
      (err) => {
        console.log(err);
      }
    );

    if (this.id > 0 || this.isEdit) {
      !this.isEdit && this.getdata(this.id);
      this.edit = true;
    } else {
      this.user = new User();
      this.edit = false;
    }
    this.showError = false;
    this.getAllBrokers();
  }

  createForm() {
    this.documentForm = this.fb.group(
      {
        name: ["", Validators.required],
        email: ["", Validators.required],
        password: "",
        phone_code: ["+20"],
        phone_error: [""],
        phone: ["", Validators.required],
        role: ["", Validators.required],
        gender: [""],
        price_request_access: [null],
        broker_id: [""],
        job_title: null,
        facebook_url: null,
        twitter_url: null,
        instagram_url: null,
        can_print_pdf: null,
        about: null,
        id: null,
        image: null,
        image_name: null,
        can_manage_payment_plan: false,
        can_export: false,
        can_import: false,
        is_accountant_cash: null,
        hiring_date: [""],
      },
      {
        validator: (group) => {
          if (!group.controls.id.value) {
            return Validators.required(group.controls.password);
          }
          return null;
        },
      }
    );
  }

  getdata(id) {
    this.accountService.getAccount(id).subscribe(
      (data) => {
        Object.keys(data).forEach((key) => {
          if (key === "hiring_date" && data[key]) {
            data[key] = format(new Date(data[key]), "yyyy-MM-dd");
          }
        });
        console.log(data);
        this.user = data;
        this.documentForm
          .get("can_manage_payment_plan")
          .patchValue(data.can_manage_payment_plan);

        this.documentForm.get("can_export").patchValue(data.can_export);

        this.documentForm.get("can_import").patchValue(data.can_import);
        this.documentForm.get("can_print_pdf").patchValue(data.can_print_pdf);
        this.documentForm
          .get("is_accountant_cash")
          .patchValue(data.is_accountant_cash);
        this.documentForm.get("hiring_date").patchValue(data.hiring_date);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  receivePhone(event, obj, phone, code, err) {
    console.log(event);
    this.documentForm.get(phone).setValue(event.phone);
    this.documentForm.get(code).setValue(event.code);
    this.documentForm.get(err).setValue(event.phoneError);
    // this[obj][err] = event.phoneError;
    // this[obj][phone] = event.phone;
    // this[obj][code] = event.code;
  }

  getAllBrokers() {
    this.accountService.getBrokers().subscribe((res) => {
      this.brokers = res;
    });
  }

  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.documentForm
          .get("image")
          .setValue((reader.result as any).split(",")[1]);
        this.documentForm.get("image_name").setValue(file.name);
      };
    }
  }

  onDocumentSubmit() {
    const formModel = this.documentForm.value;
    if (formModel.role == "Broker Agent" && !this.user.brokerCompany) {
      swal("You must choose Brokerage Company", "", "error");
      return;
    }
      console.log(formModel);
    if (formModel.name && formModel.email && formModel.phone) {
      const data = {
        id: formModel.id,
        name: formModel.name,
        email: formModel.email,
        password: formModel.password,
        job_title: formModel.job_title,
        phone: formModel.phone,
        facebook_url: formModel.facebook_url,
        twitter_url: formModel.twitter_url,
        instagram_url: formModel.instagram_url,
        can_print_pdf: formModel.can_print_pdf,
        image: formModel.image,
        image_name: formModel.image_name,
        role: formModel.role.id,
        gender: formModel.gender,
        price_request_access: formModel.price_request_access,
        broker_id: formModel.broker_id,
        can_manage_payment_plan: formModel.can_manage_payment_plan,
        can_export: formModel.can_export,
        can_import: formModel.can_import,
        hiring_date: formModel.hiring_date,
        about: formModel.about,
        is_accountant_cash: formModel.is_accountant_cash,
        phone_code: formModel.phone_code
      };
      console.log(data);
      if (this.edit === false) {
        this.accountService.createaccount(data).subscribe(
          (res) => {
            this.router.navigate(["pages/settings/accounts"]);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else {
        this.accountService.editaccount(data.id, data).subscribe(
          (respo) => {
            this.router.navigate(["pages/settings/accounts"]);
          },
          (err) => this.errorHandlerService.handleErorr(err)
        );
      }
    } else {
      this.showError = true;
      this.messages = "";
      if (!formModel.name.valid) {
        this.messages = "Name Field is invalid";
      }
      if (!formModel.email.valid) {
        this.messages = "Email Field is invalid";
      }
      if (!formModel.password.valid) {
        this.messages = "Password Field is invalid";
      }
      if (!formModel.phone.valid) {
        this.messages = "Phone Field is invalid";
      }
    }
  }

  alertRequired(e) {
    e.target.parentElement.style.display = "none";
  }

  changeManagePaymentPlanSelect(event) {
    console.log(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/accounts/add-account/add-account.component.ts